export default {
  root: {
    width: '80%',
    alignItems: 'start',
    marginLeft: 0,
  },
  selectInput: {
    background: '#F7F8FA',
    marginTop: '0.3rem',
    padding: '10px',
  },
  label: {
    textTransform: 'uppercase',
    fontSize: '10px',
    fontWeight: 700,
    color: '#484B50',
    letterSpacing: '2px',
    transform: 'translate(0, 1.5px)',
  },
  progress: {
    width: '100%',
  },
};
